<template>
<div class="chartBox posR">
	<Loading ref="Loading"></Loading>
	<div v-if="data.length>0" class="chart pl1x pr1x" :class="chartClass"></div>
	<NoResult v-if="data.length==0" :class="chartClass"></NoResult>
</div>
</template>
<script>
import * as lib from "@/util/lib.js";
import Loading from "@/components/common/ui/Loading.vue";
import NoResult from "@/components/common/ui/NoResult.vue";
import {drawAlarmTime} from "@/util/chart.js";
export default{
	name:"ChartTime",
	components:{Loading,NoResult},
	props:{
		data:{
			type:Array,
			default:function(){
				return [];
			}
		},
		lastValidTime:{
			type:Number,
			default:function(){
				return null;
			}
		},
		option:{
			type:Object,
			default:function(){
				return {
					yTitle:[""]
				};
			}
		},
		chartClass:{//图表需要的class
			type:String,
			default:""
		},
		// timezone:{
		//  	type:String,
		//  	default:stage.time.timeZoneCode
		// }
	},
	data(){
		return{
		}
	},
	watch:{
		data:function(data){
			this.run();
		}
	},
	methods:{
		run:function(){
			this.$refs.Loading.hide();
			this.$nextTick(()=>{
				if(this.data.length>0) drawAlarmTime($(this.$el).find(".chart")[0],this.data,this.lastValidTime,this.option);
			});
		}
	},
	created(){},
	mounted(){
		// trace(this.data)
	}
}
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/chart/ChartTime.vue